import React from 'react';
import "./happy.css";
import egm from "../imgz/Champagne-HD-Wallpaper.jpg";
import Sample from '../carousel/Sample';

import Fb from "@material-ui/icons/Facebook"
import Insta from "@material-ui/icons/Instagram"
import Utube from "@material-ui/icons/YouTube"
import { Link } from 'react-router-dom';


function Happy() {
    return (
        <div id="customers" className="happy">
            <div className="hap">
                <img src={egm} className="touch" alt="" />
                <h1>HAPPY CLIENTS</h1>
                <div className="black">
                  <Sample/>     
                </div>
            </div>
            <div id="contact" className="fuut">
                <div className="toto">
            <div className="left">
               <div className="part">
                   <h2>HOME</h2>
                   <h2>ABOUT US</h2>
                   <h2>SERVICES</h2>
                   
               </div>

               <div className="part">
                   <h2>EXPERIENCE</h2>
                   <h2>PORTFOLIO</h2>
                   <h2>CONTACT</h2>
               </div>
            </div>
             
            <div className="light">
                <h2>Dar-es-salaam Tanzania</h2>
                <h2>MASTERMINDZ@gmail.com</h2>
            </div>
            <div className="sosayati">
                <h2>Follow us on Social Media</h2>
            <div className="social">
              <div className="icon"><Link to="/facebook" style={{textDecoration: "none"}} ><Fb style={{color: "white", height: "8vh"}} /></Link></div>
              <div className="icon"><Link to="/instagram" style={{textDecoration: "none"}} ><Insta style={{color: "white", height: "8vh" }} /></Link></div>
              <div className="icon"><Link to="/youtube" style={{textDecoration: "none"}} ><Utube style={{color: "white", height: "8vh" }} /></Link></div>
            </div>
            </div>
                </div>
                
                <div className="down">
               <h2>Copyright&copy;2023 MindzWebsites</h2>            
                <h2>| All Rights Reserved</h2>
            </div>
            </div>
            
            
        </div>
    )
}

export default Happy
